import { SVGProps } from 'react';

function Attention(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 13.5a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5v0"
        stroke="#E72369"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.5v-5"
        stroke="#E72369"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        clipRule="evenodd"
        d="M10.08 2.173a1.204 1.204 0 0 0-2.16 0L1.603 15.04a1.014 1.014 0 0 0 .91 1.46h12.971a1.014 1.014 0 0 0 .911-1.46L10.081 2.173Z"
        stroke="#E72369"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Attention.defaultProps = {
  role: 'attention',
};

export default Attention;
